var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8143 19.9261L30.5308 40.0878H35.7841L39.068 19.9261H33.8143ZM26.1108 19.9261L21.1021 33.7931L20.5097 30.8071L20.5101 30.808L20.3795 30.1388C19.7733 28.8335 18.3694 26.3527 15.7184 24.2356C14.9347 23.6098 14.1446 23.0757 13.3809 22.6195L17.933 40.0878H23.4065L31.765 19.9261H26.1108ZM46.6137 25.5234C46.6137 23.2439 51.73 23.5368 53.9781 24.7745L54.7277 20.4443C54.7277 20.4443 52.4141 19.5652 50.0025 19.5652C47.3953 19.5652 41.2044 20.7044 41.2044 26.2396C41.2044 31.4489 48.4707 31.5137 48.4707 34.2486C48.4707 36.9836 41.9536 36.4948 39.8028 34.7695L39.0212 39.2956C39.0212 39.2956 41.3668 40.4348 44.9517 40.4348C48.5362 40.4348 53.9454 38.5794 53.9454 33.5324C53.9454 28.2905 46.6137 27.8023 46.6137 25.5234ZM68.0512 19.9261H63.8273C61.877 19.9261 61.402 21.4286 61.402 21.4286L53.5676 40.0878H59.0432L60.1386 37.0932H66.8172L67.4334 40.0878H72.2571L68.0512 19.9261ZM61.6525 32.9558L64.4131 25.4108L65.966 32.9558H61.6525Z",
    fill: "#005BAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.813 21.8243C18.813 21.8243 18.5955 20.0046 16.2741 20.0046H7.84L7.74121 20.3466C7.74121 20.3466 11.7953 21.1723 15.6847 24.2659C19.4015 27.2226 20.614 30.9083 20.614 30.9083L18.813 21.8243Z",
    fill: "#F6AC1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.8931772fabfba16a3c6cc292de0184ab.svg";
export { ForwardRef as ReactComponent };